import { appConfig as $config } from '../../app.config';
import { fUploader } from '../fUploader';
import { Common } from '../Common';

export const addPngFileDialog = (function () {
  let $fup = null;
  let $fileData = null;

  let mapping = {
    mockupOut: (data) => {
      return {
        acceptedFile: '.png',
        downloadName: null,
        fileData: null,
        fileName: data.fileName,
        fileStorageName: data.fileStorageName,
        fileType: 1,
        folderName: 'masterproductdatarow',
        signedUri: null,
        uploadMultiple: false,
        uri: Common.fixedEncodeURI(data.uri)
      };
    }
  };

  let dialog = ({ title: title, message: message, callback: callback }) => {
    bootbox
      .dialog({
        title: title,
        message: message,
        size: 'large',
        className: 'modal-scrolled-content mpd-addnewfile-modal-dialog',
        buttons: {
          Ok: {
            label: `<i class="fal fa-save"></i> ${$lang.btn.save}`,
            className: 'btn btn-brand',
            callback: callback
          },
          Close: {
            label: `<i class="fal fa-times"></i> ${$lang.btn.cancel}`,
            className: 'btn btn-link'
          }
        }
      })
      .init(init);
  };

  let init = () => {
    fileUploaderInit($config.filesModel['1']);
  };

  let fileUploaderInit = (options) => {
    $fup = new fUploader('input[type="file"]', {
      ...options,
      ...{
        autostart: true,
        pageType: 'MasterProductDataRow',
        blockEl: '.mpd-addnewfile-modal-dialog .modal-content',
        complete: uploadComplete
      }
    });
  };

  let uploadComplete = (data) => {
    $fileData = data;
  };

  return ({ title, data = {}, ok = () => {} }) => {
    let template = require('./tmpl/add-file.hbs');

    dialog({
      title,
      message: template(data),
      callback: () => {
        if (!$fileData) {
          return false;
        }

        ok(mapping.mockupOut($fileData[0]));
      }
    });
  };
})();
